// extracted by mini-css-extract-plugin
export var container = "_8y-0";
export var icon = "_8y-1";
export var text = "_8y-2";